<script setup lang="ts">
import { MediaItem } from '@/modules/media-library/components/media-library.interface';
import MediaGrid from './MediaGrid.vue';
import MediaDetails from './MediaDetails.vue';

const emit = defineEmits<{
   (e: 'onDelete', id: number): void;
   (e: 'onEdit', payload: { id: number; name: string }): void;
   (e: 'onSelect', id: number): void;
}>();

const props = defineProps<{
   media: MediaItem[];
   selectedMedia: MediaItem | null;
   showImages?: boolean;
   showVideos?: boolean;
}>();
</script>

<template>
   <div class="media-library-layout">
      <MediaGrid
         :media="media"
         :selectedMedia="selectedMedia"
         :showImages="showImages"
         :showVideos="showVideos"
         @on-select="$emit('onSelect', $event)"
      />
      <MediaDetails :selectedMedia="selectedMedia" @on-delete="$emit('onDelete', $event)" @on-edit="$emit('onEdit', $event)" />
   </div>
</template>

<style lang="scss" scoped>
.media-library-layout {
   margin-top: var(--nxt-gutter);
   display: flex;
   gap: var(--nxt-gutter-large);
   width: 100%;
}
</style>
